import React from "react"
import styles from "./Spinner.scss"

interface IProps {
  centered: boolean
}

const Spinner = ({ centered = true }: IProps) => (
  <div
    className={[styles["lds-ripple"], centered ? "" : styles.notCentered].join(
      " "
    )}
  >
    <div />
    <div />
  </div>
)

export default Spinner
